import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import { isIOS, isAndroidChrome } from '../../../helpers/serverRenderingUtils';
import {
  AppStoreButton,
  PlayStoreButton,
} from '../../components/AppDownloadButtons';
import Box from '../../shared/Box';
import Text from '../../shared/Text';
import OutboundLink from '../../components/OutboundLink';
import Image from '../../shared/Image';
import Heading from '../../shared/Heading';
import ScreenSection from '../../shared/ScreenSection';
import Footer from '../../components/Footer';
import If from '../../shared/If';
import styles from './styles.sass';

const smallScreenSize = {
  MIN: 0,
  MAX: 480,
};
const mediumScreenSize = {
  MIN: 481,
  MAX: 1024,
};
const largeScreenSize = {
  MIN: 1024,
};

const howItWorksSteps = [
  {
    title: 'Meet your sponsor',
    description:
      'Activate Sponsorships and we’ll match you with a brand that wants to sponsor your show.',
  },
  {
    title: 'Record your message',
    description:
      'Use your own voice and customize the message so it fits the tone of your podcast.',
  },
  {
    title: 'Get paid for your plays',
    description:
      'Enable Sponsorships in any of your episodes, and you’ll get paid every time your ad is heard.',
  },
];

const becomeASponsorSteps = [
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/audience.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/audience@2x.png',
    title: 'Reach the right audience, at scale',
    description:
      'Host-read podcast ads are more effective than any other form of digital advertising, and Anchor powers more new podcasts than any other platform.',
  },
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/budget.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/budget@2x.png',
    title: 'Easy podcast advertising on any budget',
    description:
      'Take the pain out of podcast advertising: easily find shows that fit your brand, and run advertisements that match your budget and needs.',
  },
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/script.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/script@2x.png',
    title: 'Set-up that’s easy, efficient and flexible',
    description:
      'Submit a script for your sponsored message, which will be recorded by participating podcast hosts and programatically served to their audiences.',
  },
];

// todo: can be a statelesscomponent
class SponsorshipsPage extends Component {
  // TODO (bui): remove inline styles
  constructor(props) {
    super(props);
    this.forPodcastersRef = React.createRef();
    this.forBrandsRef = React.createRef();
  }

  render() {
    return (
      <Box
        testId="SponsorshipsScreen"
        dangerouslySetInlineStyle={{
          overflow: 'hidden',
        }}
      >
        <Box
          testId="SponsorshipsScreen_header-section"
          paddingTop={76}
          mdPaddingTop={60}
          dangerouslySetInlineStyle={{
            background: '#292F36',
          }}
        >
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            className={styles.sponsorshipsHeader}
            minHeight={800}
            color="#2a2d35"
          >
            <Box
              testId="SponsorshipsScreen_header-section_content"
              maxWidth={1015}
              width="100%"
              paddingLeft={30}
              paddingRight={30}
            >
              <Box paddingBottom={40}>
                <h1 className={styles.topHeaderText}>Anchor Sponsorships</h1>
                <h2 className={styles.topSubheaderText}>
                  A new world for podcast advertising
                </h2>
                <Box
                  alignContent="center"
                  justifyContent="center"
                  mdPaddingTop={40}
                  lgPaddingTop={40}
                  smPaddingTop={25}
                  dangerouslySetInlineStyle={{
                    'text-align': 'center',
                  }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      window.scrollTo(0, this.forPodcastersRef.offsetTop);
                    }}
                    className={styles.forPodcastersButton}
                  >
                    For podcasters
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      window.scrollTo(0, this.forBrandsRef.offsetTop);
                    }}
                    className={styles.forBrandsButton}
                  >
                    For brands
                  </button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <ScreenSection color="#ffffff">
          <Box
            testId="SponsorshipsScreen_about-section"
            justifyContent="center"
            display="flex"
            paddingTop={40}
            paddingBottom={40}
            paddingLeft={30}
            paddingRight={30}
            marginTop={-1}
          >
            <Box
              testId="SponsorshipsScreen_about-section_top-content"
              maxWidth={950}
              display="flex"
              justifyContent="around"
              alignItems="center"
              wrap
              width="100%"
            >
              <Box align="center" maxWidth={780}>
                <Box paddingTop={8} paddingBottom={20}>
                  <Heading size="md" isBold>
                    Meet the first podcast advertising platform for everyone.
                  </Heading>
                </Box>
                <Box paddingTop={8} paddingBottom={8}>
                  <Text size="xl" align="center">
                    Anchor Sponsorships makes it easy for podcasters to get
                    sponsors, create custom ads, and make money. Currently
                    available in the U.S.; expanding to more countries soon.
                  </Text>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            testId="SponsorshipsScreen_about-section_content"
            justifyContent="center"
            display="flex"
            paddingTop={40}
            paddingBottom={40}
            paddingLeft={30}
            paddingRight={30}
            smPaddingTop={20}
          >
            <Box
              maxWidth={950}
              display="flex"
              justifyContent="around"
              alignItems="center"
              wrap
              width="100%"
              className={styles.aboutContentWrapper}
            >
              <Box
                testId="SponsorshipsScreen_about-steps-section_bullet-section"
                maxWidth={450}
                width="100%"
                className={styles.aboutSimplifyText}
                smMarginTop={20}
              >
                <Box paddingTop={8} paddingBottom={8}>
                  <Heading size="md" isBold>
                    Simplify the ad process
                  </Heading>
                </Box>
                <Box paddingTop={8} paddingBottom={8}>
                  <Box paddingBottom={32}>
                    <Text size="xl">
                      Match with sponsors, record your own custom ad, and
                      publish to any of your episodes.
                    </Text>
                  </Box>
                  <Box>
                    <Text size="xl">
                      You get to choose which sponsors you work with and where
                      in your episodes you want your ads to appear.
                    </Text>
                  </Box>
                </Box>
              </Box>
              <Box
                testId="SponsorshipsScreen_about-steps-section_image-section"
                className={styles.aboutSimplifyImage}
              >
                <Image
                  imageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/space_sm.gif"
                  retinaImageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/space_sm.gif"
                  width="100%"
                />
              </Box>
            </Box>
          </Box>
          <Box
            justifyContent="center"
            display="flex"
            paddingTop={40}
            paddingBottom={80}
            paddingLeft={30}
            paddingRight={30}
            smPaddingTop={20}
          >
            <Box
              maxWidth={950}
              display="flex"
              justifyContent="around"
              alignItems="center"
              wrap
              width="100%"
              className={styles.aboutContentWrapper}
            >
              <Box className={styles.aboutMonetizeImage}>
                <Image
                  imageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/mountain_sm.gif"
                  retinaImageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/mountain_sm.gif"
                  width="100%"
                />
              </Box>
              <Box
                maxWidth={450}
                width="100%"
                smMarginTop={20}
                className={styles.aboutMonetizeText}
              >
                <Box paddingTop={8} paddingBottom={8}>
                  <Heading size="md" isBold>
                    Monetize your plays
                  </Heading>
                </Box>
                <Box paddingTop={8} paddingBottom={8}>
                  <Box paddingBottom={32}>
                    <Text size="xl">
                      Once your ad starts getting played, you’ll get paid, and
                      you can cash out at any time.
                    </Text>
                  </Box>
                  <Box>
                    <Text size="xl">
                      The more your podcast grows, the more money you’ll be able
                      to make.
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </ScreenSection>
        <ScreenSection color="#292F36">
          <Box testId="SponsorshipsScreen_how-it-works-section">
            <Box
              justifyContent="center"
              display="flex"
              paddingTop={70}
              paddingBottom={70}
              paddingLeft={30}
              paddingRight={30}
            >
              <Box
                testId="SponsorshipsScreen_how-it-works-section_content"
                maxWidth={780}
              >
                <Box paddingTop={8} paddingBottom={8} marginBottom={60}>
                  <div
                    ref={el => {
                      this.forPodcastersRef = el;
                    }}
                    id="forPodcasters"
                  >
                    <Heading size="lg" align="center" color="#ffffff" isBold>
                      How it works
                    </Heading>
                  </div>
                </Box>
                <div className={styles.sponsorshipsVideoWrapper}>
                  <iframe
                    title="How it works"
                    width="779"
                    height="438"
                    sandbox="allow-scripts allow-same-origin allow-presentation"
                    layout="responsive"
                    frameBorder="0"
                    src="https://www.youtube.com/embed/videoseries?list=PLJ_1GxcJR2S89NFDjzVOdlzpZuFBpypLP&amp;cc_load_policy=1&amp;loop=1&amp;showinfo=0&amp;autoplay=1&amp;mute=1&amp;rel=0&amp;ytp-pause-overlay=0 "
                    scrolling="no"
                    allow="autoplay; fullscreen"
                    className={styles.sponsorshipsVideo}
                  >
                    <img
                      alt="man recording a podcast using Anchor for iPhone"
                      layout="fill"
                      src="https://d12xoj7p9moygp.cloudfront.net/images/home-video-placeholder-2.jpg"
                      placeholder
                    />
                  </iframe>
                </div>
                <Box paddingTop={8} paddingBottom={8}>
                  <Box justifyContent="center" display="flex">
                    <Box maxWidth={1000} width="100%">
                      <Box
                        testId="SponsorshipsScreen_how-it-works-section_steps"
                        display="flex"
                        justifyContent="around"
                        wrap
                        className={styles.stepsSection}
                      >
                        {howItWorksSteps.map((step, index) => (
                          <Box
                            key={step.title}
                            width={230}
                            marginLeft={10}
                            marginRight={10}
                            marginTop={15}
                            marginBottom={15}
                          >
                            <Box
                              testId="SponsorshipsScreen_how-it-works-section_step-icon-container"
                              display="flex"
                              justifyContent="center"
                              marginBottom={31}
                              className={styles.howItWorksStepsInt}
                              color="#3E444A"
                              direction="column"
                              dangerouslySetInlineStyle={{
                                'margin-left': 'auto',
                                'margin-right': 'auto',
                              }}
                            >
                              {index + 1}
                            </Box>
                            <Box marginBottom={8}>
                              <Heading
                                size="xs"
                                align="center"
                                color="#ffffff"
                                isBold
                              >
                                {step.title}
                              </Heading>
                            </Box>
                            <Box>
                              <Text size="md" align="center" color="#ffffff">
                                {step.description}
                              </Text>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                  <Box
                    paddingTop={30}
                    alignContent="center"
                    justifyContent="center"
                    dangerouslySetInlineStyle={{
                      'text-align': 'center',
                    }}
                  >
                    <Box>
                      <OutboundLink to="/signup">
                        <button
                          className={styles.signUpNowButton}
                          type="button"
                        >
                          Sign up now!
                        </button>
                      </OutboundLink>
                      <OutboundLink to="https://anch.co/sponsorships-faq">
                        <button
                          className={styles.learnMoreButton}
                          type="button"
                        >
                          Learn more
                        </button>
                      </OutboundLink>
                    </Box>
                    <Box>
                      <OutboundLink to="/login">
                        <button
                          className={styles.existingAccountButton}
                          type="button"
                        >
                          Log in to existing account
                        </button>
                      </OutboundLink>
                    </Box>
                    <Box
                      alignContent="center"
                      justifyContent="center"
                      alignItems="center"
                      direction="column"
                    >
                      <If
                        condition={isIOS()}
                        ifRender={() => (
                          <AppStoreButton
                            height={50}
                            width={169}
                            className={styles.mobileAppLink}
                          />
                        )}
                      />

                      <If
                        condition={isAndroidChrome()}
                        ifRender={() => (
                          <PlayStoreButton
                            height={50}
                            width={169}
                            className={styles.mobileAppLink}
                          />
                        )}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </ScreenSection>
        <ScreenSection color="#ffffff">
          <Box testId="SponsorshipsScreen_become-a-sponsor-section">
            <Box
              justifyContent="center"
              display="flex"
              paddingTop={70}
              paddingBottom={70}
              paddingLeft={30}
              paddingRight={30}
            >
              <Box
                testId="SponsorshipsScreen_become-a-sponsor_content"
                maxWidth={780}
              >
                <Box paddingTop={8} paddingBottom={8} marginBottom={37}>
                  <div
                    ref={el => {
                      this.forBrandsRef = el;
                    }}
                    id="forBrands"
                  >
                    <Heading size="lg" align="center" isBold>
                      Become a sponsor
                    </Heading>
                  </div>
                </Box>
                <Box paddingTop={8} paddingBottom={8}>
                  <Box justifyContent="center" display="flex">
                    <Box maxWidth={1000} width="100%">
                      <Box
                        testId="SponsorshipsScreen_become-a-sponsor_steps"
                        display="flex"
                        justifyContent="around"
                        wrap
                        className={styles.stepsSection}
                      >
                        {becomeASponsorSteps.map(step => (
                          <Box
                            key={step.title}
                            width={230}
                            marginLeft={10}
                            marginRight={10}
                            marginTop={15}
                            marginBottom={15}
                          >
                            <Box
                              testId="SponsorshipsScreen_become-a-sponsor_step-icon-container"
                              display="flex"
                              justifyContent="center"
                              marginBottom={31}
                            >
                              <Image
                                imageUrl={step.imageUrl}
                                retinaImageUrl={step.retinaImageUrl}
                                width={100}
                                height={100}
                              />
                            </Box>
                            <Box marginBottom={8}>
                              <Heading size="xs" align="center" isBold>
                                {step.title}
                              </Heading>
                            </Box>
                            <Box>
                              <Text size="md" align="center">
                                {step.description}
                              </Text>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box
                  paddingTop={30}
                  alignContent="center"
                  justifyContent="center"
                  dangerouslySetInlineStyle={{
                    'text-align': 'center',
                  }}
                >
                  <Box>
                    <OutboundLink to="https://anch.co/brands">
                      <button className={styles.getInTouchButton} type="button">
                        Get in touch
                      </button>
                    </OutboundLink>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </ScreenSection>
        <ScreenSection color="#ffffff">
          <Box
            className={styles.mountainSeperator}
            width="100%"
            minHeight={574}
          />
        </ScreenSection>
        <ScreenSection color="#ffffff">
          <Box
            testId="SponsorshipsScreen_example-brands-section"
            justifyContent="center"
            display="flex"
            paddingTop={80}
            paddingBottom={80}
            paddingLeft={30}
            paddingRight={30}
          >
            <Box
              testId="SponsorshipsScreen_example-brands-section_content"
              maxWidth={800}
            >
              <Box marginBottom={18}>
                <Heading size="md" align="center" isBold>
                  Brands already using Anchor Sponsorships
                </Heading>
              </Box>
              <Box
                testId="SponsorshipsScreen_example-brands_images"
                display="flex"
                justifyContent="around"
                wrap
                marginTop={60}
                marginBottom={60}
              >
                <MediaQuery query={`(max-width: ${smallScreenSize.MAX}px)`}>
                  <Box width="100%" maxWidth={163}>
                    <Image
                      imageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/mobile_brands.png"
                      retinaImageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/mobile_brands@2x.png"
                      width="100%"
                    />
                  </Box>
                </MediaQuery>
                <MediaQuery
                  query={`(min-width: ${
                    mediumScreenSize.MIN
                  }px) and (max-width: ${mediumScreenSize.MAX}px)`}
                >
                  <Box width="100%" maxWidth={589}>
                    <Image
                      imageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/tablet_brands.png"
                      retinaImageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/tablet_brands@2x.png"
                      width="100%"
                    />
                  </Box>
                </MediaQuery>
                <MediaQuery query={`(min-width: ${largeScreenSize.MIN}px)`}>
                  <Image
                    imageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/desktop_brands.png"
                    retinaImageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/sponsorships/desktop_brands@2x.png"
                    width={778}
                    height={141}
                  />
                </MediaQuery>
              </Box>
              <div className={styles.andMore}>
                <div className={styles.andMoreSeparator} />
                <div className={styles.andMoreText}>...and more!</div>
              </div>
            </Box>
          </Box>
        </ScreenSection>
        <Footer />
      </Box>
    );
  }
}

export default SponsorshipsPage;
